import {Map} from 'immutable'
import {apiv3} from 'lib/apiv3'
import {fulfilled} from 'lib/promiseMiddlewareHelpers'
import {loadAllPages} from 'lib/loadAllPages'

export const LOAD_EVENTS = 'events/LOAD_EVENTS'
export const CREATE_EVENT = 'events/CREATE_EVENT'

const initialState = Map({
  'events': Map()
})

export const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case fulfilled(LOAD_EVENTS): {
      return state.mergeIn(['events'], action.payload.results.map(e => [e.id, e]))
    }
    case fulfilled(CREATE_EVENT): {
      const event = action.payload.result
      return state.setIn(['events', event.id], event)
    }
    default:
      return state
  }
}

export const loadEvents = (params, clearPrevious) => ({
  type: LOAD_EVENTS,
  payload: apiv3.events.list(params),
  meta: {clearPrevious}
})

// provide a callback to store events in extra-redux places
export const loadAllEvents = (params, callback = null) => (dispatch) => {
  const loadEventsPage = ({pageIndex, perPage}) => {
    const {clearPrevious, ...filteredParams} = params

    return dispatch(loadEvents({ page: pageIndex, per_page: perPage, ...filteredParams }, pageIndex === 0 && clearPrevious))
      .then((response) => {
        callback && callback(response)
        return response
      })
  }

  const isLastPage = ({perPage, pageIndex, pageResults}) => (
    perPage * (pageIndex + 1) >= pageResults.value.total_count
  )

  return loadAllPages({
    promiseProducer: loadEventsPage,
    perPage: 200,
    isLastPage})
}

export const createEvent = (params) => ({
  type: CREATE_EVENT,
  payload: apiv3.events.create(params)
})
